import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var RightTrimPipe = (function () {
    function RightTrimPipe() {
    }
    RightTrimPipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text)
            ? text.replace(new RegExp("[" + chars + "]+$"), '')
            : text;
    };
    RightTrimPipe.decorators = [
        { type: Pipe, args: [{ name: 'rtrim' },] },
    ];
    /** @nocollapse */
    RightTrimPipe.ctorParameters = function () { return []; };
    return RightTrimPipe;
}());
export { RightTrimPipe };
//# sourceMappingURL=rtrim.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/rtrim.js
// module id = 286
// module chunks = 4